import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public static readonly DEV_PWD_KEY = 'devPassword';
  public static readonly DEV_PWD = 'M@g!Pall3t';
  public protectedAcces = environment.protectedAcces;

  public form: FormGroup<{
    devPassword: FormControl<string>
  }>;

  constructor(private translate: TranslateService) {
    this.form = new FormGroup<{
      devPassword: FormControl<string>
    }>({
      devPassword: new FormControl<string>(''),
    });

    const lang = localStorage.getItem('lang');
    translate.setDefaultLang('fr');
    translate.use(lang || 'fr');
  }

  public setDevPassword(): void {
    localStorage.setItem(
      AppComponent.DEV_PWD_KEY,
      this.form.get(AppComponent.DEV_PWD_KEY).value
    );
  }

  public get allowedAccess(): boolean {
    return (
      !this.protectedAcces ||
      localStorage.getItem(AppComponent.DEV_PWD_KEY) === AppComponent.DEV_PWD
    );
  }
}
